const indexItems = [
  {
    id: 1,
    title: '韩漫精选',
    icon: 'ri-global-line',
    desc: '韩国漫画精选合集，从热门连载到小众精品一网打尽',
    count: '5,200+部',
    color: 'accent',
  },
  {
    id: 2,
    title: '日漫殿堂',
    icon: 'ri-earth-line',
    desc: '日本经典漫画殿堂，收录从昭和到令和的各时代名作',
    count: '8,400+部',
    color: 'primary',
  },
  {
    id: 3,
    title: '热血格斗',
    icon: 'ri-boxing-line',
    desc: '燃烧斗志的热血格斗漫画专题，每一拳都让人肾上腺素飙升',
    count: '876部',
    color: 'accent',
  },
  {
    id: 4,
    title: '恋爱甜宠',
    icon: 'ri-heart-pulse-line',
    desc: '甜蜜浪漫的恋爱漫画合集，从校园初恋到职场恋情应有尽有',
    count: '1,892部',
    color: 'primary',
  },
  {
    id: 5,
    title: '悬疑推理',
    icon: 'ri-search-eye-line',
    desc: '烧脑悬疑推理漫画专题，每一页都隐藏着意想不到的线索',
    count: '987部',
    color: 'secondary',
  },
  {
    id: 6,
    title: '奇幻异世界',
    icon: 'ri-planet-line',
    desc: '穿越异世界的奇幻冒险故事，在这里你可以成为任何你想成为的人',
    count: '3,156部',
    color: 'accent',
  },
  {
    id: 7,
    title: '完结佳作',
    icon: 'ri-check-double-line',
    desc: '已经完结的高分漫画作品，一口气看到结局不用等待更新',
    count: '6,800+部',
    color: 'secondary',
  },
];

const colorMap: Record<string, { bg: string; iconBg: string; iconText: string; badge: string }> = {
  primary: {
    bg: 'hover:bg-primary-50 border-primary-100/50',
    iconBg: 'bg-primary-100',
    iconText: 'text-primary-600',
    badge: 'bg-primary-100 text-primary-700',
  },
  accent: {
    bg: 'hover:bg-accent-50 border-accent-100/50',
    iconBg: 'bg-accent-100',
    iconText: 'text-accent-600',
    badge: 'bg-accent-100 text-accent-700',
  },
  secondary: {
    bg: 'hover:bg-secondary-50 border-secondary-100/50',
    iconBg: 'bg-secondary-100',
    iconText: 'text-secondary-600',
    badge: 'bg-secondary-100 text-secondary-700',
  },
};

export default function IndexSection() {
  return (
    <section id="index" className="w-full py-16 md:py-22 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-4xl text-foreground-950">
            主题索引
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-500">
            按分类查找你感兴趣的漫画类型
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {indexItems.map((item) => {
            const c = colorMap[item.color];
            return (
              <div
                key={item.id}
                className={`bg-background-100 rounded-xl p-5 border border-background-200/60 transition-colors cursor-pointer ${c.bg} ${
                  item.id === 7 ? 'lg:col-span-3 xl:col-span-1' : ''
                }`}
              >
                <div className="flex items-start gap-4">
                  <div className={`w-11 h-11 rounded-xl ${c.iconBg} flex items-center justify-center flex-shrink-0`}>
                    <i className={`${item.icon} text-lg ${c.iconText}`}></i>
                  </div>
                  <div className="flex-1 min-w-0">
                    <div className="flex items-center gap-2 flex-wrap">
                      <h3 className="font-heading text-base text-foreground-900 whitespace-nowrap">
                        {item.title}
                      </h3>
                      <span className={`px-2 py-0.5 rounded text-xs font-bold ${c.badge} whitespace-nowrap`}>
                        {item.count}
                      </span>
                    </div>
                    <p className="mt-1.5 text-sm text-foreground-500 leading-relaxed">
                      {item.desc}
                    </p>
                  </div>
                  <div className="w-8 h-8 flex items-center justify-center flex-shrink-0">
                    <i className="ri-arrow-right-s-line text-foreground-400"></i>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}